/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PencilIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g id="pencil">
      <path d="M7.68616667,20.86875 L1.759,22.2593333 L3.14958333,16.3330833 L17.4495833,2.03125 C18.1655,1.31533333 19.3278333,1.31533333 20.0428333,2.03125 L21.988,3.97641667 C22.703,4.69233333 22.703,5.85283333 21.988,6.56966667 L7.68616667,20.86875 Z" />
      <path d="M21.34175,7.21866667 L16.8015,2.67933333" />
      <path d="M20.0336667,8.52675 L15.5053333,3.9755" />
      <path d="M7.91716667,20.6386667 L3.37966667,16.1011667" />
    </g>
  </svg>
);

export default PencilIcon;
